import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from './axios';

export const getNotifications = createAsyncThunk('getNotifications', async () => {
    const response = await axios.get('user/notifications');

    // console.log('getNotifications', response.data);
    if (response.status === 200 && typeof response.data === 'object') {
        return response.data.data ?? [];
    } else {
        throw 'error';
    }
});

export const setNotificationSeen = createAsyncThunk('setNotificationSeen', async ({ id }: { id: number }) => {
    const response = await axios.put(`user/notifications/seen/${id}`);

    // console.log('getNotifications', response.data);
    if (response.status === 200 && typeof response.data === 'object') {
        return id;
    } else {
        throw 'error';
    }
});

export const setNotificationViewed = createAsyncThunk('setNotificationViewed', async ({ id }: { id: number }) => {
    const response = await axios.put(`user/notifications/viewed/${id}`);

    // console.log('setNotificationViewed', response.data);
    if (response.status === 200 && typeof response.data === 'object') {
        return id;
    } else {
        throw 'error';
    }
});

export const dismissAllNotifications = createAsyncThunk('dismissAllNotifications', async () => {
    const response = await axios.put(`user/notifications/seen-all`);

    // console.log('dismissAllNotifications', response.data);
    if (response.status === 200 && typeof response.data === 'object') {
        return true;
    } else {
        throw 'error';
    }
});
